import React, { useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import { addDays } from 'date-fns';
import { DateRangePicker } from 'react-date-range';
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../store/pageHeader/action";
import Dashboard from './dashboard'

const ManagementDashboard = () => {
  const dispatch = useDispatch();
  dispatch(StorePageHeaderName('Dashboard'))
  
  const [open, setOpen] = useState(false)
  document.title = "Dashboard | Procurement Dashboard";
  const top100Films = [
    { label: 'The Shawshank Redemption', year: 1994 },
    { label: 'The Godfather', year: 1972 },
    { label: 'The Godfather: Part II', year: 1974 },
    { label: 'The Dark Knight', year: 2008 },
    { label: '12 Angry Men', year: 1957 },]
  const handleProductNameClick = (isOpen) => {
    setOpen(isOpen)
  };
  const [showList, setShowList] = useState(false);

  const toggleList = () => {
    setShowList(!showList);
  };

  const approvalcolumns = [
    { field: 'Sl_No', headerName: 'Sl.No', 
    headerAlign: 'center',
    cellClassName: 'center-aligndata',
    resizable: false,
    sortable: false,
    flex: 1,
    },
    // {
    //     field: 'Requisition_No',
    //     headerName: 'Requisition No',
    //     headerClassName: 'table-header-background',
    //     // width: 160,
    //     editable: true,
    // },
    {
        field: 'Product_Name',
        headerName: 'Product Name',
        headerClassName: 'break-header',
        cellClassName: 'product_name_wrap',
        width: 200,
        resizable: false,
        sortable: false,
        editable: true,
        renderCell: (params) => {
            const productName = params.value;
            return (
                <div style={{ cursor: 'pointer' }} onClick={() => handleProductNameClick(true)}>
                    {productName}
                </div>
            );
        },
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
    //   description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      flex: 1,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 160,
  },
  {
      field: 'dP_Value',
      headerName: 'DP Value',
    //   description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      flex: 1,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 160,
  },
  {
      field: 'MOP',
      headerName: 'FOB',
    //   description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      flex: 1,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 160,
  },
  {
      field: 'vendor_name',
      headerName: 'Vendor Name',
      cellClassName: 'product_name_wrap',
    //   description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      flex: 1,
      // width: 160,
  },
  {
      field: 'payment_term',
      headerName: 'Payment Term',
    //   description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      flex: 1,
      headerClassName: 'break-header',
        cellClassName: 'product_name_wrap',
      // width: 160,
  },
  {
      field: 'actual_date',
      headerName: 'Actual Date',
    //   description: 'This column has a value getter and is not sortable.',
      sortable: false,
      resizable: false,
      flex: 1,
      headerAlign: 'center',
      cellClassName: 'center-aligndata',
      // width: 160,

  },
  {
    field: 'PO_no',
    headerName: 'PO No.',
    // description: 'This column has a value getter and is not sortable.',
    sortable: false,
    resizable: false,
    flex: 1,
    headerAlign: 'center',
    cellClassName: 'center-aligndata',
    // width: 160,

},
    {
        field: 'Status',
        headerName: 'Status',
        headerClassName: 'table-header-background',
        // description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 160,
        resizable: false,
        renderCell: (params) => {
            const status = params.value;
            // Define the color for the chip based on the status
            let chipColor = 'default';
            if (status == 'Waiting for response') {
                chipColor = 'error'; // Red color for waiting for response
            } else if (status == 'approved') {
                chipColor = 'success'; // Green color for approved
            }

            // Render the Chip component with the outlined variant and appropriate color
            return <Chip className="status_badge" label={status} variant="outlined" color={chipColor} />;
        },
    },
];

const approvalrows = [
    { id: 1, Sl_No: 1, Requisition_No: 'REQ1', Requisition_Date: '-', Product_Name: 'HOBS HB-MARICA', quantity: 2, dP_Value:6055500, MOP: 658010, vendor_name:'Zhonghan Wantai', payment_term: '30% 30 Days', Actual_Date: '-',PO_no:'PO1234', Status: 'Waiting for response' },
    { id: 2, Sl_No: 2, Requisition_No: 'REQ1', Requisition_Date: '-', Product_Name: 'HOBS HB-MARICA', quantity: 2, dP_Value:6055500, MOP: 658010, vendor_name:'Zhonghan Wantai', payment_term: '30% 30 Days', Actual_Date: '-', PO_no:'PO1234', Status: 'Waiting for response' },
];
  const dateRangeData = [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection"
    }
  ]
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };
  return (
    <React.Fragment>
      {/* {
      open &&(
        <History handleProductNameClick={handleProductNameClick}/>
      )
     } */}
      <div className="page-content">
        <Container fluid>
          {/* <BreadCrumb title="Dashboard" pageTitle="Dashboard" /> */}
          <div>
            <h4 className="mb-3 requisition_text">Approval Requisitions</h4>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '17px' }}>
            <Card
              style={{
                width: 'calc(33% - 10px )',
                backgroundColor: ' #0060AA',
                borderRadius: '10px'
              }}
            >
              <CardBody>
                <CardTitle tag="h5">
                  <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                    <LibraryAddIcon />
                    <span style={{ marginLeft: '8px' }}><b>100</b></span>
                  </div>
                </CardTitle>
                <CardText>
                  <div style={{ color: 'white' }}><b>Total Number of Requisitions</b></div>
                </CardText>
              </CardBody>
            </Card>
            <Card
              style={{
                width: 'calc(33% - 10px )',
                // width: '24rem',
                backgroundColor: ' #29AD08',
                borderRadius: '10px'
              }}
            >
              <CardBody>
                <CardTitle tag="h5">
                  <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                    <b> <DoneAllIcon /></b>
                    <span style={{ marginLeft: '8px', color: 'white' }}><b>80</b></span>
                  </div>
                </CardTitle>
                <CardText>
                  <div style={{ color: 'white' }}><b>Approved Requisitions </b></div>
                </CardText>
              </CardBody>
            </Card>
            <Card
              style={{
                width: 'calc(33% - 10px )',
                backgroundColor: '#FF5A5A',
                borderRadius: '10px'
                // width: '24rem'
              }}
            >
              <CardBody>
                <CardTitle tag="h5">
                  <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                    <span><CloseIcon /></span>
                    <span style={{ marginLeft: '8px', color: 'white' }}>20</span>
                  </div>
                </CardTitle>
                <CardText>
                  <div style={{ color: 'white' }}><b>Not Approved Requisition</b></div>
                </CardText>
              </CardBody>
            </Card>
          </div>
          <Dashboard />
          {/* <div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div>
                                <h4 className="mb-0 requisition_text">Requisitions History</h4>
                            </div>
                            <div>
                                <Button variant="outlined" className="filter_button">View All</Button>
                            </div>
                        </div>

                        <Box sx={{ height: 400, width: '100%', marginBottom: '10px' }}>
                            <DataGrid
                                className="table_header_background"
                                headerClassName="custom-header-cell"
                                rows={approvalrows}
                                columns={approvalcolumns}
                                initialState={{
                                    // pagination: {
                                    //     paginationModel: {
                                    //         pageSize: 5,
                                    //     },
                                    // },
                                }}
                                pageSizeOptions={[]}
                                disableRowSelectionOnClick
                            />
                        </Box>
         </div> */}
        </Container>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        className="datepicker_modal modal_box"
      >
        {/* <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do You Want To Submit This Requsition</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={closeModal}></i>
                    </div>
                </div>
                <hr className='mb-2 mt-1 ms-3 me-3'></hr> */}
        <ModalBody className='pt-2'>
          <div>
            <DateRangePicker
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              editableDateInputs={true}
              ranges={dateRangeData}
              direction="horizontal"
              className="w-100 datepicker_customise"
              rangeColors={['#0060AA']}
            />
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ManagementDashboard;
